import { z } from 'zod';

/**
 * Every error response has this shape. `code` is machine-readable and is what
 * clients translate (D-010, D-020); `message` is for developers only.
 */
export const ApiErrorSchema = z.object({
  code: z
    .string()
    .regex(/^[a-z]+(?:[._][a-z0-9]+)+$/, 'Expected a dotted code such as route.not_found'),
  message: z.string(),
  requestId: z.string().min(1).optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;
